import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M8 .667c4.05 0 7.333 3.283 7.333 7.333 0 4.05-3.283 7.333-7.333 7.333C3.95 15.333.667 12.05.667 8 .667 3.95 3.95.667 8 .667zM8 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 1.333c.368 0 .667.299.667.667v3.724l1.804 1.805c.26.26.26.682 0 .942-.26.26-.682.26-.942 0l-2-2c-.125-.125-.196-.294-.196-.471V4c0-.368.299-.667.667-.667z",
		transform: "translate(-1280 -664) translate(1072 520) translate(16 120) translate(184 16) translate(8 8)"
	})
});
export default SvgClock;
